import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Item} from "../../../shared/models/item";
import {Waiter} from "../../../shared/models/waiter";

@Component({
  selector: 'app-waiter-overview-details',
  templateUrl: './waiter-overview-details.component.html',
  styleUrl: './waiter-overview-details.component.scss'
})
export class WaiterOverviewDetailsComponent {

  waiter: Waiter;
  waiterForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<WaiterOverviewDetailsComponent>) {
    this.waiter = data.waiter;
    this.waiterForm = this.formBuilder.group({
      firstName: [this.waiter.firstName, Validators.required],
      lastName: [this.waiter.lastName, Validators.required],
      street: [this.waiter.street],
      houseNumber: [this.waiter.houseNumber],
      zip: [this.waiter.zip],
      city: [this.waiter.city],
      country: [this.waiter.country],
      mobileNumber: [this.waiter.mobileNumber],
      email: [this.waiter.email],
      tenantName: [this.waiter.tenantName]
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.waiterForm.valid) {
      // get raw value returns all values including disabled (case for infinite quantity)
      const editedWaiter: Waiter = this.waiterForm.getRawValue();
      this.dialogRef.close(editedWaiter);
    }
  }


}
